import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PageHeader } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { DISPLAY_MODE } from "Constants";
import { useStoreState } from "easy-peasy";
import FourOThree from "Pages/private/403";
import React, { useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import HousingScoringForm from "Pages/private/master-data/housing-scoring/components/form";
import { GenerateBackPath } from "Utils";

export default function NewHousingScoringPage({ ...props }) {
  const history = useHistory();
  const match = useRouteMatch();

  const [housingScoring, setHouseScoring] = useState({
    children: 0,
    childrenScore: 0,
    housingPreviously: 0,
    housingPreviouslyScore: 0,
    married: false,
    wifeScore: 0,
    housingMunicipalityContiguousIn: 0,
    housingMunicipalityContiguousInScore: 0,
    housingMunicipalityContiguousOut: 0,
    housingMunicipalityContiguousOutScore: 0,
    task: { taskOrder: 0 },
    title: { titleOrder: 0 },
    termOfOfficeScore: 0,
    termOfOffice: 0,
    veteranScore: 0,
    salaryExceptScore: 0,
    obligatedOtherPerson: 0,
    housingDemandWaitingScore: 0,
    disabilitySituationScore: 0,
    disabilityFamilyMembersScore: 0,
    allocationBasicScore: 0,
  });
  const { abilities } = useStoreState((store) => store.auth);

  return (
    <>
      <PageHeader
        className="customized"
        backIcon={<FontAwesomeIcon icon={["fas", "chevron-left"]} />}
        onBack={() => {
          history.push(GenerateBackPath(match.path, 4));
        }}
        title={"Yeni Konut Puanlama Formu"}
      />
      {AuthCheck(
        abilities,
        AUTH_ACTIONS.NEW_RECORD,
        "Konut Puanlama Formları"
      ) ? (
        <HousingScoringForm
          mode={DISPLAY_MODE.NEW}
          housingScoring={housingScoring}
          onAfterSuccess={(response) => {
            history.push(
              `${GenerateBackPath(match.path, 4)}/${response?.id}/detay`
            );
          }}
        />
      ) : (
        <FourOThree />
      )}
    </>
  );
}
